import { IAppState } from '../../redux';
import { selectIsMasterMoneySource } from './selectIsMasterMoneySource';
import { selectSubagentSpendLimit } from './selectSubagentSpendLimit';

export const selectBalance = (state: IAppState): number => {
  const {
    user: { balance, agencyBalance },
  } = state;

  const isMasterMoneySource = selectIsMasterMoneySource(state);
  const limitedBalance = selectSubagentSpendLimit(state);

  return isMasterMoneySource ? limitedBalance || agencyBalance : balance;
};
